import { fromJS } from 'immutable';
import {
    PROCEDURES_GET_FAILED,
    PROCEDURES_GET,
    PROCEDURES_GET_SUCCESS
} from '../actions/procedures';

const initialState = fromJS({
    isFetching: false,
    isFailed: false,
    data: []
});

const branches = (state = initialState, action) => {
    switch(action.type) {
        case PROCEDURES_GET:
            return state.merge(
                {
                    isFetching: true
                }
            );

        case PROCEDURES_GET_SUCCESS:
            return state.merge(
                {
                    isFetching: false,
                    data: action.procedures
                }
            );

        case PROCEDURES_GET_FAILED:
            return state.merge(
                {
                    isFetching: false,
                    isFailed: true
                }
            );

        default:
            return state;
    }
};

export default branches;


/** WEBPACK FOOTER **
 ** ./src/reducers/procedures.js
 **/